import { ICourseInstanceReducer } from '../Interfaces/ICourseInstanceReducer';
import {
  IApiJsonResponse,
  IMetadata,
} from '../../../__core/Interfaces/IApiResponse';
import { ICourseInstance } from '../../../__core/Interfaces/ICourseInstance';
import { ICourse } from '../../../__core/Interfaces/ICourse';
import { InstanceAccessResponse } from '../Types/InstanceAccessResponse';
import { gradebookInitState } from '../Components/Gradebook/Reducers/InitState';
import { sharingLoaderInitState } from '../Components/Sharing/Reducers/InitState';

export const metadataWithPagingInitState: IMetadata = {
  currentPage: 0,
  totalItems: 0,
  perPage: 0,
  pages: 0,
};

export const metadataWithNavigationInitState: IMetadata = {
  navigation: {
    contentLevel: 'chapter',
    nextChapterId: null,
    nextMaterialId: null,
    nextSlug: null,
    previousChapterId: null,
    previousMaterialId: null,
    previousSlug: null,
  },
};

export const instanceInitState: IApiJsonResponse<ICourseInstance> = {
  data: {
    id: '',
    signature: '',
    selfRegister: false,
    links: {
      schedule: '',
      classroom: '',
      chat: '',
      records: '',
      trello: '',
      jira: '',
      testlink: '',
    },
    courseId: '',
    access: {
      role: '',
      modules: [],
    },
    mentor: { name: '' },
    cs: { name: '' },
    description: '',
    currentMaterial: { id: '', name: '', chapterId: '' },
    product: {
      name: '',
      id: '',
    },
    icon: '',
    roles: [],
  },
  metadata: metadataWithPagingInitState,
};

export const courseInstanceDetailsInitState: IApiJsonResponse<ICourse> = {
  data: {
    id: '',
    version: '',
    modules: [],
    product: { id: '0', name: '' },
    hasRepositories: true,
  },
  metadata: metadataWithPagingInitState,
};

export const instanceAccessForStudentsInitState: InstanceAccessResponse = {
  data: [],
  metadata: {},
};

export const instanceAccessForLecturesInitState: InstanceAccessResponse = {
  data: [],
  metadata: {},
};

export const lecturerAccessForModulesInitState: IApiJsonResponse<
  Array<number>
> = {
  data: [],
  metadata: {},
};

export const courseInstanceInitState: ICourseInstanceReducer = {
  details: courseInstanceDetailsInitState,
  instance: instanceInitState,
  instanceAccessForStudents: instanceAccessForStudentsInitState,
  instanceAccessForLectures: instanceAccessForLecturesInitState,
  lecturerAccessForModules: lecturerAccessForModulesInitState,
  gradebook: gradebookInitState,
  sharingLoaders: sharingLoaderInitState,
};
